import React from 'react';

function ConnectionSpeed({
    connectionSpeed
}) {

    return (
        <div className="flex flex-row items-center justify-center">
            {/* <span className="font-normal text-gray-400 text-sm">
                {
                    connectionSpeed ? `Your connection speed is ${connectionSpeed.text}` : "Checking your connection speed..."
                } 
            </span>
            <span className={`w-2 h-2 rounded-full ml-2 mt-0.5 ${connectionSpeed?.colorClass}`} /> */}
        </div>
    );
}

export default ConnectionSpeed;